export default function QuestionIcn() {
  return <svg viewBox="0 0 79 79">
    <path
      d="M39.5 5.375c-18.845 0-34.125 15.28-34.125 34.125S20.655 73.625 39.5 73.625 73.625 58.345 73.625 39.5 58.345 5.375 39.5 5.375zm0 62.46c-15.646 0-28.336-12.69-28.336-28.335 0-15.646 12.69-28.336 28.336-28.336 15.646 0 28.336 12.69 28.336 28.336 0 15.646-12.69 28.336-28.336 28.336z"
      />
    <path
      d="M48 24.621c-2.286-2.003-5.302-3.1-8.501-3.1-3.2 0-6.216 1.104-8.501 3.1-2.377 2.08-3.687 4.875-3.687 7.869v.579c0 .335.274.61.61.61h3.656c.335 0 .61-.275.61-.61v-.58c0-3.358 3.282-6.093 7.312-6.093s7.312 2.735 7.312 6.094c0 2.369-1.675 4.54-4.273 5.538a8.514 8.514 0 0 0-3.968 3.115 8.72 8.72 0 0 0-1.516 4.944v1.637c0 .335.274.61.61.61h3.655c.335 0 .61-.275.61-.61v-1.729a3.678 3.678 0 0 1 2.353-3.412c4.495-1.73 7.397-5.69 7.397-10.093.007-2.994-1.303-5.79-3.68-7.869zM36.452 56.255a3.047 3.047 0 1 0 6.094 0 3.047 3.047 0 0 0-6.094 0z"
      />
  </svg>

}
